module.exports = __webpack_public_path__ + "img/FPT16.805ca820.svg";